import { render, staticRenderFns } from "./merge_action.vue?vue&type=template&id=241a4536&scoped=true&"
import script from "./merge_action.vue?vue&type=script&lang=js&"
export * from "./merge_action.vue?vue&type=script&lang=js&"
import style0 from "./merge_action.vue?vue&type=style&index=0&id=241a4536&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241a4536",
  null
  
)

export default component.exports